import * as sprintfJs from 'sprintf-js';

export function sprintf(value: string, ...args: any[]): string {
    return sprintfJs.sprintf(value, ...args);
}
